import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { BaseView, TranslatePipe } from 'O3_core';
import { ISmsQueue } from '../interfaces/sms-queue.interface';
import { ISmsStatus } from '../interfaces/sms-status.interface';
import { SmsQueueService } from '../services/sms-queue.service';
import { SmsStatusService } from '../services/sms-status.service';

@Component({
  selector: 'o3-notifications-sms-queue-detail',
  imports: [CommonModule, TranslatePipe, RouterModule],
  templateUrl: './detail.html',
  styleUrl: './detail.css',
})
export class SmsQueueDetail extends BaseView implements OnInit {
  private readonly smsQueueService = inject(SmsQueueService);
  private readonly smsStatusService = inject(SmsStatusService);

  sms = signal<ISmsQueue | null>(null);
  smsStatus = signal<ISmsStatus | null>(null);
  isLoading = signal<boolean>(true);

  ngOnInit(): void {
    const id = this.activatedRoute.snapshot.paramMap.get('id');
    if (id) {
      this.loadSms(id);
    }
  }

  private async loadSms(id: string): Promise<void> {
    this.isLoading.set(true);
    try {
      const [smsData, statusResult] = await Promise.all([
        firstValueFrom(this.smsQueueService.getById(id)),
        firstValueFrom(this.smsStatusService.list({})),
      ]);
      this.sms.set(smsData);

      const status = (statusResult?.items ?? []).find(
        (s: ISmsStatus) => s.code === smsData.status,
      );
      this.smsStatus.set(status || null);
    } catch (error) {
      this.processError(error);
    } finally {
      this.isLoading.set(false);
    }
  }

  goBack(): void {
    this.router.navigate(['/notifications/sms-queue']);
  }

  formatJson(value: unknown): string {
    if (value == null) return '';
    try {
      return JSON.stringify(value, null, 2);
    } catch {
      return String(value);
    }
  }
}
